import * as React from 'react';
import Popover from '@mui/material/Popover';
import {
  TableContainer, ThemeProvider,
} from '@mui/material';
import { useState } from 'react';
import { reportMixPanel } from '@55degrees/consent-tracker';
import {
  FilterListButton,
  FilterListButtonIcon,
  FilterListResetButton,
  FilterListTable,
  FilterListTitle,
  FilterListHeaderCell, FilterListHeader, FilterListHeaderRow,
} from './style';
import SelectedFiltersInfoBox from './SelectedFiltersInfoBox';
import getTheme from '../../../../themes/helper';

function SelectedFiltersDialog({
  filters,
  isDarkMode,
  setResetFiltersScope,
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { itemFilters, workflowStages } = filters;

  const checkFiltersLength = (itemFilters && (Object.entries(itemFilters).map(([key]) => (
    Object.keys(itemFilters[key]).length > 0
  ))));

  const checkUncheckedStagesLength = (workflowStages && (Object.entries(workflowStages).map(([key]) => (
    (key === 'global')
      ? workflowStages[key].slice(1).filter((item) => item.isChecked === false).length > 0
      : workflowStages[key].filter((item) => item.isChecked === false).length > 0
  ))));

  const itemFiltersHaveValues = checkFiltersLength?.some(
    (boolValue) => boolValue === true,
  );
  const workflowStagesHaveValues = checkUncheckedStagesLength?.some(
    (boolValue) => boolValue === true,
  );

  const toggleDialog = (event) => {
    setDialogOpen((prevState) => {
      reportMixPanel('Filter Info View');
      return !prevState;
    });
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popover' : undefined;

  return (
    <ThemeProvider theme={getTheme(isDarkMode)}>
      {(itemFiltersHaveValues || workflowStagesHaveValues) ? (
        <>
          <FilterListButton
            color="primary"
            value="popover"
            aria-describedby={id}
            onClick={toggleDialog}
            sx={{
              backgroundColor: open ? (isDarkMode ? '#1c2b41' : '#e9f2ff') : 'none',
              borderRadius: '3px',
              // we might want to only have mui components later to use the same color palette ⬆️
            }}
          >
            <FilterListButtonIcon />
          </FilterListButton>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            sx={{ width: '100%', maxHeight: '100%', marginTop: 1 }}
          >
            <TableContainer sx={{ height: 'fit-content', width: 301 }}>
              <FilterListTable stickyHeader aria-label="sticky table">
                <FilterListHeader>
                  <FilterListHeaderRow>
                    <FilterListHeaderCell>
                      <FilterListTitle>
                        Selected Filters
                      </FilterListTitle>
                      <FilterListResetButton
                        color="warning"
                        onClick={() => {
                          setResetFiltersScope('all');
                          handleClose();
                        }}
                      >
                        Clear All
                      </FilterListResetButton>
                    </FilterListHeaderCell>
                  </FilterListHeaderRow>
                </FilterListHeader>
                <SelectedFiltersInfoBox
                  filters={filters}
                  setResetFiltersScope={setResetFiltersScope}
                  handleClose={handleClose}
                />
              </FilterListTable>
            </TableContainer>
          </Popover>
        </>
      ) : null}
    </ThemeProvider>
  );
}

export default SelectedFiltersDialog;
